import React from "react";
import { FaBars } from "react-icons/fa";
import Links from "../constants/links";

const Navbar = ({ onShowSidebar, navbarFixedClass }) => {
  return (
    <nav className={`nav ${navbarFixedClass}`} id="nav">
      <div className="nav-center">
        <div className="nav-header">
          <button onClick={onShowSidebar} className="nav-btn" id="nav-btn">
            <FaBars />
          </button>
        </div>

        <Links styleClass="nav-links" />
      </div>
    </nav>
  );
};

export default Navbar;
